import {
   AP_MAUD_MAP_IMAGE_URL,
   AP_MAUD_RIGHT_SIDE_BG_IMG,
   AP_PLACES_BOTTOM_BANNER,
   LOGIN_BG_IMG
} from '../constants'
import { ClientConfigType, ClientWebAppMobileConfigType } from './types'

const config: ClientConfigType = {
   rightRegistered: 'Developed by Deepwork Technologies Pvt Ltd',
   login: {
      logoURL: './assets/images/ap_maud_logo.png',
      logoWidth: 420
   },
   navbar: {
      logoURL: '/assets/images/ap_ma&ud_navbar_logo.svg'
   },
   enableSupportRequest: false,
   loginLayout: {
      type: 'LEFT_ALIGNED',
      footerImageUrl: AP_PLACES_BOTTOM_BANNER,
      footerHeight: 96,
      bgImgUrl: LOGIN_BG_IMG,
      poster: {
         imageUrl: AP_MAUD_MAP_IMAGE_URL,
         patternUrl: AP_MAUD_RIGHT_SIDE_BG_IMG
      }
   },
   privacyPolicyAndTC: {
      privacyPolicyUrl: 'https://buildnow.telangana.gov.in/privacy-policy',
      termsAndConditionsUrl:
         'https://buildnow.telangana.gov.in/terms-and-conditions'
   }
}

export default config

export const apMaAndUdWebAppMobileScreenConfig: ClientWebAppMobileConfigType = {
   appLogo: '/assets/images/ap_ma&ud_navbar_logo.svg',
   appPreviewImageUrl: '/images/web-page-mobile-view.png',
   bgImageUrl: '/icons/mobile-view-supported-bg-image.svg'
}
